import { EMatchingType } from '@enums/campaign-analytics.enum';
import { IAnalyticsNode, ICtaResult } from '@interfaces/campaign-analytics.interface';
import { isCtaResultCounted } from '@shared/components/social-content-tile/social-content-tile.util';

/**
 * Whether a node belongs to a group the way Goals counts it: a planned / missing node by its group; a content when its
 * result for the group counts there (a bonus counted for another group is not this group's extra; Optional groups
 * count every evaluation).
 */
export function isAnalyticsNodeInGroup(node: IAnalyticsNode, groupId: string, optional = false): boolean {
  if (node.nonExecutedCtaId === groupId) {
    return true;
  }

  const ctaResults = [...(node.content?.ctas?.values() ?? [])];
  const ctaResult = node.content?.ctas?.get(groupId);

  return !!ctaResult && isCtaResultCounted(ctaResults, ctaResult, optional);
}

/** A content's result for one of its groups; the tile and the dialog then show that group, not the default one. */
export function getGroupCtaResult(node: IAnalyticsNode, groupId: string): ICtaResult | undefined {
  return node.content?.ctas?.get(groupId) as ICtaResult | undefined;
}

/**
 * Deep-link matching types limited to what the matching select offers: an unoffered type would filter invisibly.
 * Nothing left → the tab's default (every offered type but unrelated). No requested types → no matching filter.
 */
export function getDeepLinkMatchingTypes(
  requested: Set<EMatchingType> | undefined,
  offered: EMatchingType[],
): Set<EMatchingType> {
  if (!requested) {
    return new Set();
  }

  const visible = [...requested].filter((type) => offered.includes(type));

  return new Set(visible.length ? visible : offered.filter((type) => type !== EMatchingType.unrelated));
}
